import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { GoogleOAuthProvider } from '@react-oauth/google';
import config from './config.dev';

// Get Google OAuth Client ID based on hostname
const getGoogleClientId = (): string => {
  const hostname = window.location.hostname;
  const clients = config.GOOGLE_OAUTH_CLIENTS as Record<string, string>;
  const clientId = clients[hostname];
  
  if (!clientId) {
    console.warn(`No Google OAuth Client ID configured for hostname: ${hostname}`);
    // Fallback to the first available client ID
    return Object.values(clients)[0];
  }
  
  return clientId;
};

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <GoogleOAuthProvider clientId={getGoogleClientId()}>
      <App />
    </GoogleOAuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
